import { Heading } from "@chakra-ui/react";
import React from "react";

interface IPageHeading {
  title?: string;
}

const PageHeading: React.FC<IPageHeading> = ({ title }: IPageHeading) => {
  return (
    <Heading as="h1" fontSize="50px" mt="88px" mb="88px" pl="16px">
      {title}
    </Heading>
  );
};

export default PageHeading;
